import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'cleave.js/dist/addons/cleave-phone.in';
import 'react-toastify/dist/ReactToastify.css';
import 'react-loading-skeleton/dist/skeleton.css';
//import Scss
import './assets/scss/themes.scss';

// remixicon
import 'remixicon/fonts/remixicon.css';

//import Route
import Route from './Routes';

function App() {
  return (
    <React.Fragment>
      <ToastContainer />
      <Route />
    </React.Fragment>
  );
}

export default App;
